// extracted by mini-css-extract-plugin
export default {"messageContainer":"style_messageContainer__+UB0g","messageList":"style_messageList__decJi","messageItem":"style_messageItem__XgDxL","mobile":"style_mobile__raF-r"};